var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBulletListSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 6.875C7.29167 7.33524 6.91857 7.70833 6.45833 7.70833C5.9981 7.70833 5.625 7.33524 5.625 6.875C5.625 6.41476 5.9981 6.04167 6.45833 6.04167C6.91857 6.04167 7.29167 6.41476 7.29167 6.875Z",
    fill: "#9B9DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.875C8.75 6.52982 9.02982 6.25 9.375 6.25H13.9583C14.3035 6.25 14.5833 6.52982 14.5833 6.875C14.5833 7.22018 14.3035 7.5 13.9583 7.5H9.375C9.02982 7.5 8.75 7.22018 8.75 6.875Z",
    fill: "#9B9DAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75005 10C8.75005 9.65482 9.02987 9.375 9.37505 9.375H13.9583C14.3035 9.375 14.5833 9.65482 14.5833 10C14.5833 10.3452 14.3035 10.625 13.9583 10.625H9.37505C9.02987 10.625 8.75005 10.3452 8.75005 10Z",
    fill: "#9B9DAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37505 12.5C9.02987 12.5 8.75005 12.7798 8.75005 13.125C8.75005 13.4702 9.02987 13.75 9.37505 13.75H13.9583C14.3035 13.75 14.5833 13.4702 14.5833 13.125C14.5833 12.7798 14.3035 12.5 13.9583 12.5H9.37505Z",
    fill: "#9B9DAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45833 10.8333C6.91857 10.8333 7.29167 10.4602 7.29167 10C7.29167 9.53976 6.91857 9.16667 6.45833 9.16667C5.9981 9.16667 5.625 9.53976 5.625 10C5.625 10.4602 5.9981 10.8333 6.45833 10.8333Z",
    fill: "#9B9DAA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 13.125C7.29167 13.5852 6.91857 13.9583 6.45833 13.9583C5.9981 13.9583 5.625 13.5852 5.625 13.125C5.625 12.6648 5.9981 12.2917 6.45833 12.2917C6.91857 12.2917 7.29167 12.6648 7.29167 13.125Z",
    fill: "#9B9DAA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 2.5C3.33947 2.5 2.5 3.33947 2.5 4.375V15.625C2.5 16.6605 3.33947 17.5 4.375 17.5H15.625C16.6605 17.5 17.5 16.6605 17.5 15.625V4.375C17.5 3.33947 16.6605 2.5 15.625 2.5H4.375ZM3.75 4.375C3.75 4.02982 4.02982 3.75 4.375 3.75H15.625C15.9702 3.75 16.25 4.02982 16.25 4.375V15.625C16.25 15.9702 15.9702 16.25 15.625 16.25H4.375C4.02982 16.25 3.75 15.9702 3.75 15.625V4.375Z",
    fill: "#9B9DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBulletListSquare);
export default __webpack_public_path__ + "static/media/text_bullet_list_square.56c184c0bbc077c43ca5aca41adad3aa.svg";
export { ForwardRef as ReactComponent };